// Components==============
import indexJobs from 'actions/job/index';
import indexOrionJobs from 'actions/job-orion/index';
import indexDiscipline from 'actions/discipline/index';
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import PageHeader from 'components/UI/PageHeader/PageHeader';
import React, { createContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVacancyShorthand } from 'utilities/getVacancyShorthand';
import VacancyCard from 'components/Layout/components/VacancyCard/VacancyCard';
import FilterMenu from './components/FilterMenu/FilterMenu';
import './Vacancies.module.scss';
// =========================

export const VacanciesContext = createContext({});

const colors = Array(50)
    .fill([
        { name: 'primary', hex: '#1e265c' },
        { name: 'purple', hex: '#6e38a6' },
        { name: 'yellow', hex: '#f4bb56' },
        { name: 'blue', hex: '#2db1d8' },
    ])
    .flat();

export default function Vacancies() {
    const [searchValue, setSearchValue] = useState('');
    const [selectedEmployment, setSelectedEmployment] = useState([]);
    const [selectedSector, setSelectedSector] = useState([]);
    const [selectedEducationLevel, setSelectedEducationLevel] = useState([]);
    const [selectedAvailability, setSelectedAvailability] = useState([]);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(indexDiscipline());
        dispatch(indexJobs());
        dispatch(indexOrionJobs());
    }, []);

    // Grijp je kans in het onderwijs vacancies
    const vacancies = useSelector((state) =>
        state.job.entities.allIds.map((id) => state.job.entities.byId[id])
    );

    // Orion vacancies
    const orionVacancies = useSelector((state) =>
        state.jobOrion.entities.allIds.map((id) => {
            const job = state.jobOrion.entities.byId[id];
            if (job.type === 'docent') {
                job.type = 'op';
            }
            switch (job.beschikbaarheid) {
                case 'fulltime':
                    job.beschikbaarheid = 'voltijd';
                    break;

                case 'parttime':
                    job.beschikbaarheid = 'deeltijd';
                    break;

                case 'both':
                    job.beschikbaarheid = 'voltijd-of-deeltijd';
                    break;

                default:
                    break;
            }
            switch (job.dienstverband) {
                case 'tijdelijk':
                    job.dienstverband = 'Tijdelijk';
                    break;

                case 'structureel':
                    job.dienstverband = 'Vast';
                    break;

                case 'tijdelijk-uitzicht':
                    job.dienstverband = 'Tijdelijk met uitzicht op vast';
                    break;

                default:
                    break;
            }
            job.sector = 'vo';
            const school = {
                logo: `https://ontwikkelplatformnxt.nl${job?.organisation?.logo}`,
                contact: {
                    website: job?.organisation?.website
                        ? job?.organisation?.website
                        : job?.organisation?.contact.website,
                },
                name: job?.organisation?.schoolGroup_id ? job?.organisation?.school_group?.name : job?.organisation?.name
            };
            job.school = school;

            return job;
        })
    );

    const combinedJobs = [...orionVacancies, ...vacancies]
        .filter(
            (vacancy) =>
                // search
                (vacancy?.name
                    .toLowerCase()
                    .includes(searchValue.toLowerCase()) ||
                    vacancy?.locatie
                        .toLowerCase()
                        .includes(searchValue.toLowerCase()) ||
                    vacancy?.school?.name
                        ?.toLowerCase()
                        .includes(searchValue.toLowerCase())) &&
                // sector
                (selectedSector.length
                    ? selectedSector.includes(vacancy.sector)
                    : true) &&
                // employment
                (selectedEmployment.length
                    ? selectedEmployment.includes(vacancy.dienstverband)
                    : true) &&
                // availability
                (selectedAvailability.length
                    ? selectedAvailability.includes(vacancy.beschikbaarheid)
                    : true) &&
                // function
                (selectedEducationLevel.length
                    ? selectedEducationLevel.includes(
                          getVacancyShorthand(vacancy.type)
                      )
                    : true)
        )
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    return (
        <VacanciesContext.Provider
            value={{
                searchValue,
                setSearchValue,
                selectedEmployment,
                setSelectedEmployment,
                selectedSector,
                setSelectedSector,
                selectedEducationLevel,
                setSelectedEducationLevel,
                selectedAvailability,
                setSelectedAvailability,
            }}
        >
            <Layout>
                <PageHeader />
                <Container background>
                    <div styleName="wrapper">
                        <FilterMenu />
                        <div styleName="cards">
                            {combinedJobs.map((vacancy, i) => (
                                <VacancyCard
                                    vacancy={vacancy}
                                    key={vacancy.id}
                                    color={colors?.[i]}
                                />
                            ))}
                        </div>
                    </div>
                </Container>
            </Layout>
        </VacanciesContext.Provider>
    );
}
